import React from 'react';
import classes from './Button.css';
import {NavLink} from 'react-router-dom';
const button = (props) => {
    let buttonTag = null;
    let btnClasses = [props.iconBtn?classes.appBtnIcon:classes.appBtn];

    if(props.isGetInTouch) {
        btnClasses.push(classes.getInTouch);
    }

    if(props.isPrimary) {
        btnClasses.push(classes.appBtnPrimary);
    }

    if(props.isSecondary) {
        btnClasses.push(classes.appBtnSecondary);
    }

    if(props.isContactMe) {
        btnClasses.push(classes.appContactMeBtn);
    }
    if(props.isLink) {
    buttonTag =  props.to?<NavLink to={props.to} className={btnClasses.join(' ')}>{props.children}</NavLink>:
    <a href="javascript:void(0)" href={props.href} target={props.blank?'_blank':''} className={btnClasses.join(' ')}>{props.children}</a>;
    } 
    else {
        buttonTag =  <button type={props.submit?'submit':'button'} className={btnClasses.join(' ')}>{props.children}</button>;
    }
    return  buttonTag;
}



export default button;


// WEBPACK FOOTER //
// ./src/components/UI/Button/Button.js